export default __webpack_public_path__ + "dumpert-d-b896f3.svg";